<div class="panelGeofences" [ngClass]="{'expandir': fullScreen}" id="panelGeofenceContainer">
  <div class="mobile-handle" *ngIf="!mobileQuery.matches" (click)="fullScreen = !fullScreen">
    <mat-icon class="handle-arrow">{{ fullScreen ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
  </div>

  <loading [isLoading]="isLoading"></loading>
  
  <div class="header-panel">
    <div class="btnClose">
      <img [src]="'cancelar.svg' | findUrl" (click)="ClosePanel()">
    </div>

    <h3>Geocercas</h3>

    <div class="tools-buttons-container">
      <div class="tool-button" (click)="isSearchButtonPressed = !isSearchButtonPressed; isToolButtonPressed = false" id="searchGeofenceButton" matTooltip="Buscar Geocerca">
        <img [src]="'busqueda_blanco.svg' | findUrl">
      </div>
      <div class="tool-button" (click)="isToolButtonPressed = !isToolButtonPressed; isSearchButtonPressed = false" id="toolsGeofenceButton" matTooltip="Herramientas">
        <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
        <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
      </div>
    </div>
  </div>

  <div [@mostrarFiltro]="isSearchButtonPressed ? 'visible' : 'hidden'" class="search-Arrow-flex">
    <div class="searchBar-flex">
      <div class="searchBar" id="searchGeofenceInput" matTooltip="Buscar por Nombre" matTooltipPosition="above">
        <mat-form-field class="width-input">
          <input
            #filterGeofence
            [(ngModel)]="finder"
            matInput
            placeholder="Búsqueda por Nombre"
            spellcheck="false"
            type="text"
            (input)="onFindGeofence($event)"
          />
        </mat-form-field>
      </div>
      <div class="btnResetFilter-container" (click)="resetFilterValue()" *ngIf="finder.length > 0">
        <mat-icon matTooltip="Borrar" aria-hidden="false">cancel</mat-icon>
      </div>
      <div class="btnSearch-container" (click)="onFindGeofence($event)">
        <img class="btnSearchIcon" src="/assets/img/icon_search.png" *ngIf="finder.length == 0">
      </div>
    </div>
  </div>

  <div [@mostrarHerramientas]="isToolButtonPressed ? 'visible' : 'hidden'" class="button-tool-list-vertical" id="panelGeofenceButtonToolContainer">
    <location-button-toolbar 
      [isGeofencePanel]="true"
      [isVerticalList]="true">
    </location-button-toolbar>
    <app-report-list 
      id="panelGeofenceReportsButton"
      [showReportes]="false"
      [isVerticalList]="true">
    </app-report-list>
  </div>

  <div class="geofences-tab-group" *ngIf="!filter">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="custom-tab-group" [disablePagination]="true">
      <!-- primer tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="custom-tab-label">
            <mat-icon class="tab-icon active-icon">check_circle</mat-icon>
            <span>Activas</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          
          <div class="geofences-list-container">
            <div class="control-items">
              <div class="geofence-card" *ngFor="let item of $ItemsActives" (click)="onCardClicked(item.id)">
                <div class="card-content">
                  <div class="card-icon">
                    <img [src]="'geocercarOnline.png' | findUrl">
                  </div>
                  <div class="card-info">
                    <span class="card-title active">{{ item.name }}</span>
                  </div>
                </div>
              </div>
              <div class="no-results" *ngIf="$ItemsActives.length == 0 && !isLoading">
                <span class="no-results-text">No se encontraron resultados</span>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>

      <!-- segundo tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="custom-tab-label">
            <mat-icon class="tab-icon inactive-icon">cancel</mat-icon>
            <span>Inactivas</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          
          <div class="geofences-list-container">
            <div class="control-items" >
              <div class="geofence-card inactive-card" *ngFor="let item of $ItemsInactives" (click)="onCardClicked(item.id)">
                <div class="card-content">
                  <div class="card-icon">
                    <img [src]="'geocercarOffline.png' | findUrl">
                  </div>
                  <div class="card-info">
                    <span class="card-title inactive">{{ item.name }}</span>
                  </div>
                </div>
              </div>
              <div class="no-results" *ngIf="$ItemsInactives.length == 0 && !isLoading">
                <span class="no-results-text">No se encontraron resultados</span>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Lista filtrada (fuera de tabs) -->
  <div class="geofences-list-container" *ngIf="filter">
    <div class="control-items">
      <div class="geofence-card" [class.inactive-card]="$ItemsInactives.includes(item)" *ngFor="let item of $Items" (click)="onCardClicked(item.id)">
        <div class="card-content">
          <div class="card-icon">
            <img *ngIf="$ItemsActives.includes(item)" [src]="'geocercarOnline.png' | findUrl">
            <img *ngIf="$ItemsInactives.includes(item)" [src]="'geocercarOffline.png' | findUrl">
          </div>
          <div class="card-info">
            <span class="card-title" [class.active]="$ItemsActives.includes(item)" [class.inactive]="$ItemsInactives.includes(item)">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="no-results" *ngIf="$Items.length == 0 && !isLoading">
        <span class="no-results-text">No se encontraron resultados</span>
      </div>
    </div>
  </div>

</div>
